;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import Carousel from 'components/ui/Carousel';

import styles from './CardGroupCarousel.module.scss';

const CardGroupCarousel = ({
    cardMap,
    cards,
    theme,
    className,
    navigationTheme,
    ...rest
}) => {
    theme ??= 'Latest';

    const cleanCards = cards.filter(card => {
        const isRenderable =
            (cardMap[card?.__typename || 'Default'] || cardMap['Default']) !==
            null;

        if (!isRenderable && card?.__typename) {
            console.warn(
                `Card is not renderable __typename: ${card?.__typename}`
            );
        }

        return isRenderable;
    });

    const renderCards = () => {
        return cleanCards.map((card, idx) => {
            const Card =
                cardMap[card.__typename || 'Default'] || cardMap['Default'];

            if (Card == null) {
                console.warn(`Card Missing or Drafted`);
                return null;
            }

            const cardProps =
                theme === 'Recipe Products'
                    ? { ...card, headline: card.displayName || card.headline }
                    : { ...card, bgColor: card.backgroundColor };

            return (
                <div
                    key={idx}
                    className={cx(styles.item, {
                        [styles.cardIconStat]:
                            card.__typename === 'CardIconStat',
                        [styles.cardSmall]: card.__typename === 'CardSmall',
                    })}
                >
                    <div className={styles.inner}>
                        <Card
                            {...cardProps}
                            id={card.sys?.id}
                            theme={theme}
                            index={idx}
                            isInCarousel
                            {...rest}
                        />
                    </div>
                </div>
            );
        });
    };

    return (
        <div
            className={cx(styles.root, className, {
                [styles.threeUpFull]: theme === 'Campaign',
                [styles.threeUpContained]:
                    cleanCards.length < 4 && theme !== 'Campaign',
                [styles.centered]:
                    cleanCards.length < 3 ||
                    (theme === 'Recipe Products' && cleanCards.length === 1),
                [styles.inlineIntro]: theme === 'Inline Intro',
                [styles.recipes]: theme === 'Recipes',
                [styles.products]: theme === 'Products',
                [styles.recipeProducts]: theme === 'Recipe Products',
                [styles.holiday]: theme === 'Holiday',
            })}
        >
            <Carousel
                className={styles.carousel}
                navigationTheme={navigationTheme}
                slideClassName={styles.slide}
                autoScroll={false}
                inlineIntro={theme === 'Inline Intro'}
                hideScrollBars
            >
                {renderCards()}
            </Carousel>
        </div>
    );
};

CardGroupCarousel.propTypes = {
    className: PropTypes.string,
    cards: PropTypes.array.isRequired,
    cardMap: PropTypes.object,
    theme: PropTypes.string,
    navigationTheme: PropTypes.oneOf(['blue', 'cream', 'orange']),
};

export default CardGroupCarousel;
